import React from 'react';
import Form from '../../components/common/Form';

class ReassignFeedModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                feed_id: props.feed_id || "",
                team_id: props.team_id || ""
            },
            errors: {},
            selectedTeamId: '',
            selectedTeamName: '',
            checkReassign: false
        };
    }

    doSubmit = (e) => {
        e.preventDefault();
        const data = this.state.data;
        this.props.acceptModal(e, data);
    };

    selectTeam = (id, team_name) => {
        // console.log(id);
        let data_selected = this.state.data;
        data_selected.team_id = id;
        this.setState({
            selectedTeamId: id,
            data: data_selected,
            selectedTeamName: team_name
        })
    };

    reassignConfirm = () => {
        this.setState({
            checkReassign: true
        })
    }

    reassignConfirmCancel = () => {
        this.setState({
            checkReassign: false
        })
    }


    render() {
        let {visible_modal, onClickAway, teams, teams_in, team_id, feed_name } = this.props;
// console.log("ReassignFeedModal team_id", team_id);
        return (

            <div id="teamModal" className="text-left modal in" style={visible_modal ? {display: "block"} : {display: "none"}}>
                <div className="modal-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title distribution-title m-lg-b'>
                            <span>Reassign Workspace</span><br/>
                            <span>to another Team</span>
                        </h1>
                        <div className="separator"></div>
                        <div className="form-group m-m-b">

                            {/*<span className="danger-text"> <strong>Are you sure you want to reassign this feed? </strong>*/}
                            <span className="text-dark-blue">Choose to which team you want to reassign
                                <strong className="text-light-blue"> { feed_name }</strong> to.
                            </span>
                            <br/>

                            <p className='m-m-b text-center grey-text'>
                                Choose from existing teams
                            </p>
                            <form onSubmit={this.handleFormSubmit}>
                                <div id='teams'>
                                    {
                                        this.state.loading ?
                                            <h3 className="text-dark-blue text-center">Loading teams...</h3>
                                            :
                                            <React.Fragment>
                                                {
                                                    teams.map(team => {

                                                            return this.state.selectedTeamId === team.id ?

                                                                <p key={team.id} onClick={() => this.selectTeam(team.id, team.team_name)}
                                                                   className='onboarding-team selected'>{team.team_name}
                                                                </p>

                                                                :

                                                                <p key={team.id} onClick={() => this.selectTeam(team.id, team.team_name)}
                                                                   className='onboarding-team'>{team.team_name}
                                                                </p>
                                                        }
                                                    )
                                                }
                                                {
                                                    teams_in.map(team => {

                                                            return this.state.selectedTeamId === team.id ?

                                                                <p key={team.id} onClick={() => this.selectTeam(team.id, team.team_name)}
                                                                   className='onboarding-team selected'>{team.team_name}
                                                                </p>

                                                                :

                                                                <p key={team.id} onClick={() => this.selectTeam(team.id, team.team_name)}
                                                                   className='onboarding-team'>{team.team_name}
                                                                </p>
                                                        }
                                                    )
                                                }
                                            </React.Fragment>
                                    }
                                </div>

                                {/*{this.state.selectedTeamId ?*/}
                                    {/*(*/}
                                        {/*this.state.spinnerActive ?*/}

                                            {/*<button disabled={true}*/}
                                                    {/*className='btn-action btn-sm m-sm-b center'>Next <span*/}
                                                {/*className='fa fa-spin fa-spinner'></span>*/}
                                            {/*</button>*/}
                                            {/*:*/}
                                            {/*<button onClick={this.doSubmit}*/}
                                                    {/*className='btn-action btn-sm m-sm-b center'>Next*/}
                                            {/*</button>*/}

                                    {/*)*/}
                                    {/*:*/}
                                    {/*<button onClick={this.doSubmit}*/}
                                            {/*className='btn-action btn-sm m-sm-b center'>Next*/}
                                    {/*</button>*/}
                                {/*}*/}
                            </form>
                        </div>
                        <div className="separator m-m-b"></div>
                        <div className="submit-buttons row">
                            <div className="col-md-6">
                                <button disabled={false}
                                        onClick={onClickAway}
                                        name="cancel_team"
                                        id="cancel_team"
                                        type="button"
                                        className="bg-darker-blue ">Cancel</button>
                            </div>
                            <div className="col-md-6 text-right save-submit">
                                <button disabled={false}
                                        name="change_team"
                                        id="reasign_feed_btn"
                                        type="button"
                                        onClick={this.reassignConfirm}
                                        className='btn-action'>Reasign</button>
                            </div>
                        </div>
                    </div>
                </div>

                { this.state.checkReassign ?
                    <div id="are-you-sure-modal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                        <div className="modal-content">
                            <div className="onboarding-panel">
                                <h2>
                                    <span className="danger-text">
                                        <strong>Are you sure you want to reassign { feed_name } to { this.state.selectedTeamName }? </strong>
                                    </span>
                                </h2>

                                <div className="separator m-m-b"></div>
                                <div className="submit-buttons row">
                                    <div className="col-md-6">
                                        <button disabled={false}
                                                onClick={this.reassignConfirmCancel}
                                                name="cancel_team"
                                                id="cancel_team"
                                                type="button"
                                                className="bg-darker-blue ">Cancel</button>
                                    </div>
                                    <div className="col-md-6 text-right save-submit">
                                        <button disabled={false}
                                                name="change_team"
                                                id="reasign_feed_btn"
                                                type="button"
                                                onClick={this.doSubmit}
                                                className='btn-action'>Reassign</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
            </div>
        )
    }
}

export default ReassignFeedModal;